import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ConfirmWindowService } from '../../../services/confirm-window/confirm-window.service';

@Component({
  selector: 'confirm-window',
  templateUrl: './confirm-window.component.html',
})
export class ConfirmWindowComponent {

  @Input() buttonText: string;
  @Output() windowResponseEvent = new EventEmitter<boolean>();

  modalRef: BsModalRef;

  titleMessage: string;
  bodyMessage: string;
  confirmTextMessage: string;
  declineTextMessage: string;

  constructor(
    private readonly modalService: BsModalService,
    private readonly confirmWindowService: ConfirmWindowService
  ) {
    this.confirmWindowService.params.subscribe((params) => {
      this.titleMessage = params?.titleMessage;
      this.bodyMessage = params?.bodyMessage;
      this.confirmTextMessage = params?.confirmTextMessage;
      this.declineTextMessage = params?.declineTextMessage;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  confirm(): void {
    this.windowResponseEvent.emit(true);
    this.modalRef.hide();
  }

  decline(): void {
    this.windowResponseEvent.emit(false);
    this.modalRef.hide();
  }

}
